import * as React from 'react'

const HandMoneyLinear = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    ref={ref}
    {...props}
  >
    <path
      stroke="#71717A"
      strokeWidth="1.5"
      d="M17.414 10.414C18 9.828 18 8.886 18 7s0-2.828-.586-3.414m0 6.828C16.828 11 15.886 11 14 11h-4c-1.886 0-2.828 0-3.414-.586m10.828-6.828C16.828 3 15.886 3 14 3h-4c-1.886 0-2.828 0-3.414.586m0 0C6 4.172 6 5.114 6 7s0 2.828.586 3.414M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    ></path>
    <path
      stroke="#71717A"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="M18 6a3 3 0 0 1-3-3m3 5a3 3 0 0 0-3 3M6 6a3 3 0 0 0 3-3M6 8a3 3 0 0 1 3 3m-4 9.388h2.26c1.01 0 2.033.106 3.016.308 1.755.36 3.56.4 5.33.118.868-.14 1.72-.355 2.492-.727.696-.337 1.549-.81 2.122-1.341.572-.53 1.168-1.397 1.59-2.075.364-.582.188-1.295-.386-1.728a1.89 1.89 0 0 0-2.22 0l-1.807 1.365c-.7.53-1.465 1.017-2.376 1.162q-.165.026-.345.047m0 0-.11.012m.11-.012a1 1 0 0 0 .427-.24 1.49 1.49 0 0 0 .126-2.134 1.9 1.9 0 0 0-.45-.367c-2.797-1.669-7.15-.398-9.779 1.467m9.676 1.274a.5.5 0 0 1-.11.012m0 0q-.906.09-1.814.004"
    ></path>
    <path
      stroke="#71717A"
      strokeWidth="1.5"
      d="M5 15.5a1.5 1.5 0 0 0-3 0v5a1.5 1.5 0 0 0 3 0z"
    ></path>
  </svg>
))

HandMoneyLinear.displayName = 'HandMoneyLinear'

export { HandMoneyLinear }
